import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLightDown = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m35.745 12.536-1.43-1.431a.868.868 0 0 0-1.229 0L20 24.162 6.914 11.105a.868.868 0 0 0-1.229 0l-1.43 1.43a.868.868 0 0 0 0 1.23l15.13 15.13c.34.34.89.34 1.23 0l15.13-15.13a.868.868 0 0 0 0-1.23Z" })
});
export default SvgChevronLightDown;
